import { render } from "./MyInvoices.vue?vue&type=template&id=4cc1231a&scoped=true"
import script from "./MyInvoices.vue?vue&type=script&lang=js"
export * from "./MyInvoices.vue?vue&type=script&lang=js"

import "./MyInvoices.vue?vue&type=style&index=0&id=4cc1231a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc1231a"]])

export default __exports__